import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import type { RootState, AppDispatch } from './store';

// Custom hook to use the app's dispatch function, typed with AppDispatch
export const useAppDispatch = () => useDispatch<AppDispatch>();

// Custom hook to use the app's selector function, typed with RootState
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
